import { extendTheme, ThemeConfig } from '@chakra-ui/react';
import { globalStyles } from './styles';

const config: ThemeConfig = {
  initialColorMode: 'light',
  useSystemColorMode: false,
};

const theme = extendTheme({
  ...globalStyles,
  config,
  fonts: {
    heading: "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
    body: "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
  },
  components: {
    Button: {
      baseStyle: {
        fontWeight: '500',
        borderRadius: 'lg',
      },
      defaultProps: {
        colorScheme: 'brand',
      },
    },
    Card: {
      baseStyle: {
        container: {
          borderRadius: 'xl',
          boxShadow: 'sm',
          border: '1px solid',
          borderColor: 'gray.200',
        },
      },
    },
    Select: {
      baseStyle: {
        field: {
          bg: 'white',
          color: 'gray.800',
          borderColor: 'gray.200',
          _hover: {
            borderColor: 'gray.300',
          },
          _focus: {
            borderColor: 'brand.500',
            boxShadow: '0 0 0 1px var(--chakra-colors-brand-500)',
          },
          option: {
            bg: 'white',
            color: 'gray.800',
          },
        },
      },
      variants: {
        outline: {
          field: {
            bg: 'white',
            color: 'gray.800',
            _dark: {
              bg: 'white',
              color: 'gray.800',
            },
          },
        },
      },
      defaultProps: {
        variant: 'outline',
      },
    },
  },
});

export default theme;
